<template>
  <div class="content">
    <div v-if="orderlists.length == 0 && !isLoading" class="text-center">
      <div class="no-data">{{ $t("noDataOrder") }}</div>
    </div>
    <div class="text-center loading-prepare" v-if="isLoading">
      <img
        src="@/assets/images/loading-d-dots.gif"
        alt="loading"
        class="loading-icon"
      />
    </div>
    <div v-else-if="orderlists.length > 0 && !isLoading">
      <div
        v-for="(orderDetail, index) in orderlists"
        :key="index"
        class="order-detail-container px-3"
      >
        <div
          class="header d-flex justify-content-between items-align-center flex-wrap"
        >
          <div>
            <div class="font-weight-bolder status">
              <font-awesome-icon
                :icon="['fa', 'clipboard-list']"
                class="icon-status"
              />{{ orderDetail.orderStatus }}
            </div>
            <div class="tracking-no">
              {{ orderDetail.orderSn }}
              <b-button
                variant="copy-clipboard"
                v-b-tooltip.hover
                :title="tooltipText"
                @click.stop.prevent="onCopy(orderDetail.orderSn)"
                @mouseout="outCopyClipboard"
              >
                <font-awesome-icon icon="copy" />
              </b-button>
            </div>
          </div>
          <div class="text-right">
            <!-- <div class="see-detail" @click="handleSeeDetail(orderDetail)">
              ดูรายละเอียด
              <font-awesome-icon :icon="['fas', 'chevron-down']" class="icon" />
            </div> -->
            <div>
              {{ getDateByTimeStamp(orderDetail.createTime) }}
            </div>
          </div>
        </div>
        <hr />
        <div
          class="items my-3"
          v-for="(item, index) in orderDetail.itemList"
          :key="index"
        >
          <OrderCard :item-detail="item" />
        </div>
        <hr class="dash" />
        <div class="summary">
          <div class="detail d-flex justify-content-between flex-wrap">
            <div class="d-flex">
              <div class="icon-wrp">
                <font-awesome-icon :icon="['fa', 'money-bill']" />
              </div>
              {{ $t("paymentAmount") }}
            </div>
            <div class="price font-weight-bold text-end">
              {{ getCurrency(orderDetail.totalAmount) }}
            </div>
          </div>
          <div class="detail d-flex justify-content-between flex-wrap">
            <div class="d-flex">
              <div class="icon-wrp">
                <font-awesome-icon :icon="['fa', 'truck']" />
              </div>
              {{ $t("shippingInfo") }}
            </div>
            <span class="text-end">
              {{ orderDetail.shippingCarrier }}
            </span>
          </div>
          <div class="detail d-flex justify-content-between flex-wrap">
            <div class="d-flex">
              <div class="icon-wrp">
                <font-awesome-icon :icon="['fa', 'calendar']" />
              </div>
              {{ $t("prepare") }}
            </div>

            <span class="text-end"> 28 Aug 2025, 18:02 </span>
          </div>
          <div class="detail d-flex justify-content-between flex-wrap">
            <div class="d-flex">
              <div class="icon-wrp">
                <font-awesome-icon :icon="['fa', 'business-time']" />
              </div>
              {{ $t("paymentTime") }}
            </div>
            <span class="text-end">28 Aug 2025, 18:02 </span>
          </div>
          <!-- <div class="detail d-flex justify-content-between flex-wrap">
            <div class="d-flex">
              <div class="icon-wrp">
                <font-awesome-icon :icon="['fa', 'sticky-note']" />
              </div>
              บันทึกช่วยจำ
            </div>
            <span
              class="text-end note"
              :class="{ pointer: !note }"
              @click="!note && handleShowModalNote()"
            >
              {{ note ? note : "+ ใส่โน้ตช่วยจำ" }}
            </span>
          </div> -->
        </div>
        <hr class="dash" />
        <div class="footer flex-wrap">
          <!-- <button class="btn cancel">ยกเลิก</button>
      <button class="btn contact">แนะนำให้ผู้ซื้อติดต่อ Shoppee</button> -->
          <button class="btn buy" @click="onSendOrder(orderDetail)">
            {{ $t("submitOrder") }}
          </button>
        </div>

        <OrderModalNote
          ref="OrderModalNote"
          @onConfirm="note => (this.note = note)"
        />
      </div>
      <b-pagination
        v-model="currentPage"
        :total-rows="totalOrders"
        :per-page="pageSize"
        class="pagination-main pb-4"
        @change="handlePagination"
        align="center"
      ></b-pagination>
    </div>
    <ChatboxModalConfirmOrderReply
      ref="ChatboxModalConfirmOrderReply"
      @confirm="clickSelectTextReply"
    />
  </div>
</template>

<script>
import OrderCard from "./OrderCard.vue";
import OrderModalNote from "./OrderModalNote.vue";
import ChatboxModalConfirmOrderReply from "@/components/chat/chatBox/modal/ChatboxModalConfirmOrderReply";
import { EventBus } from "@/helpers/event";
import { MESSAGE_TYPES } from "@/helpers/constants.js";
import getCurrencyByMode from "@/helpers/getCurrencyByMode";

export default {
  name: "OrderDetail",
  components: {
    OrderCard,
    OrderModalNote,
    ChatboxModalConfirmOrderReply
  },
  props: {
    status: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    return {
      tooltipText: "",
      note: "",
      hasNote: false,
      currentPage: 1,
      pageSize: 10,
      totalOrders: 0,
      orderlists: [],
      isLoading: false
    };
  },
  mounted() {
    this.fetchOrderList();
  },
  methods: {
    // handleSeeDetail(orderDetail) {
    //   console.log("🚀 ~ handleSeeDetail ~ orderDetail:", orderDetail)
    //   const uri = `https://seller.th.shopee.cn/portal/sale/order/${orderDetail.id}`
    //   // window.open(uri, "_blank");
    // },
    onSendOrder(order) {
      this.$refs.ChatboxModalConfirmOrderReply.show(order);
    },
    async clickSelectTextReply(order) {
      let dataSend = {
        text: order.id,
        imageUrl: "",
        attachments: null,
        isReply: false,
        replyMessageId: "",
        custom: {
          orderSn: order.orderSn,
          totalAmount: order.totalAmount,
          orderStatus: order.orderStatus,
          shippingCarrier: order.shippingCarrier
        }
      };
      EventBus.$emit("send-message-custom", {
        data: dataSend,
        type: MESSAGE_TYPES.Order
      });
    },
    handlePagination(pageNo) {
      this.currentPage = pageNo;
      this.fetchOrderList();
    },
    getCurrency(amount) {
      const MODE = process.env.VUE_APP_MODE;
      return getCurrencyByMode(amount, MODE);
    },
    async fetchOrderList() {
      try {
        this.isLoading = true;
        const query = `?customerId=${this.$store.state.chatUserGUIDSelected}&currentPage=${this.currentPage}&limit=${this.pageSize}&status=${this.status}`;
        let result = await fetch(
          `${this.$shopeeUrl}/shopee/getOrderByCustomerId${query}`,
          {
            method: "GET",
            headers: new Headers(this.$headersChat)
          }
        );

        let resultJson = await result.json();
        this.orderlists = resultJson.detail.orders ?? [];
        this.totalOrders = resultJson.detail.total;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    getDateByTimeStamp(timestamp) {
      const date = new Date(timestamp * 1000); // ต้องคูณ 1000 ให้เป็น ms
      return this.$moment(date).format("DD MMM YYYY, HH:mm");
    },
    onSeeDetail() {},
    onCopy(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.tooltipText = this.$t("copySuccess");
        })
        .catch(err => {
          console.error("Error in copying text: ", err);
        });
    },
    outCopyClipboard() {
      this.tooltipText = this.$t("copy");
    },
    handleShowModalNote() {
      console.log("handleShowModalNote");
      this.$refs.OrderModalNote.show();
    },
    onConfirm(note) {
      console.log("onConfirm", note);
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  overflow: auto;
  width: 100%;
  height: calc(100dvh - 260px);
  padding: 20px 0px;
  position: absolute;

  &::-webkit-scrollbar {
    width: 0.35rem;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(177, 175, 175, 0.3);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
  }
}
.order-detail-container {
  background-color: #fff;
  padding: 10px 13px;
  font-size: 15px;

  .header {
    .status {
      display: flex;
      align-items: center;
      gap: 5px;

      .icon-status {
        color: #4d84e4;
        font-size: 14px;
        margin-bottom: 3px;
      }
    }

    .tracking-no {
      color: #707070;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 5px;
      .btn-copy-clipboard {
        padding: 0;
        color: #832abf;
        cursor: pointer;
        font-size: 10px;
      }
    }

    .see-detail {
      color: #832abf;
      cursor: pointer;
      font-size: 14px;

      .icon {
        transform: rotate(270deg);
        width: 10px;
        height: 10px;
      }

      + div {
        color: #707070;
        font-size: 14px;
      }
    }
  }

  .summary {
    .detail {
      font-size: 13px;
      font-weight: 100;
      margin-bottom: 5px;
      div:first-child {
        color: #9c9c9c;
      }

      .price {
        color: #832abf;
      }

      .note {
        color: #832abf;
        // cursor: pointer;
      }

      .icon-wrp {
        width: 20px;

        svg {
          width: 13px;
          height: 13px;
        }
      }
    }
  }

  .footer {
    display: flex;
    justify-content: end;
    gap: 10px;
    margin-top: 10px;

    .btn {
      padding: 5px 10px;
      border-radius: 5px;
      font-size: 14px;
      border: 1px solid #832abf;

      &.cancel,
      &.contact {
        color: #832abf;
      }

      &.buy {
        color: #fff;
        background-color: #832abf;
      }
    }
  }

  hr {
    border: none;
    border-top: 1px solid #d7d5d5;
    margin: 5px 0px;
  }

  .dash {
    width: 100%;
    border: none;
    border-top: 1px dashed #d7d5d5;
  }
}
</style>
